import { Draft } from 'immer';
import { AppState } from '../interface';
import { JarvisHomebox } from '../../../interface';
import { ProviderType } from '../enum';

/**
 * Stores the routers into the correct state based on their `providerType`.
 * @param {Draft<AppState>} draft - The state that needs to be modified.
 * @param {JarvisHomebox[]} routers - The routers that need to be stored.
 */
export const handleSetRouters = (draft: Draft<AppState>, routers: JarvisHomebox[]) => {
    for (const router of routers) {
        router.unity
            ? draft.routers.UM.push(router)
            : draft.routers.VKD.push(router);
    }
};

/**
 * Modifies provider in state, and changes the selected router
 * to the same router from the other provider (if available)
 * @param {Draft<AppState>} draft - The state that needs to be modified.
 * @param {ProviderType} providerType - The provider to change to.
 */
export const handleProviderChange = (draft: Draft<AppState>, providerType: ProviderType) => {
    if (draft.providerType === providerType) {
        return;
    }
    const prevIndex = draft.routers[draft.providerType].findIndex(({ id }) => id === draft.selectedId);

    draft.providerType = providerType;

    const routers = draft.routers[providerType];

    if (prevIndex < routers.length) {
        draft.selectedId = routers[prevIndex].id;
        return;
    }

    if (0 < routers.length) {
        draft.selectedId = routers[routers.length - 1].id;
    }
};

/**
 * Stores the new available routers in state and changes the selected
 * router if the previous one is not available
 * @param {Draft<AppState>} draft - The state that needs to be modified.
 * @param {string[]} routerIds - The ids of the available routers
 */
export const handleSetAvailableRouters = (draft: Draft<AppState>, routerIds: string[]) => {
    draft.availableRouterIds = routerIds;

    if (0 < routerIds.length && !routerIds.includes(draft.selectedId)) {
        draft.selectedId = routerIds[routerIds.length - 1];
    }
};
